<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Salary Reports</h5>
  </div>
<div id="mainContent" class="container" *ngIf="!myReportIndicator">
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Financial Year<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFinancialYear"
              (change)="onFinancialYearSlected()"
            >
              <option value="">Select Year</option>
              <option *ngFor="let finance of financialList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Branch<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <mat-select
              multiple
              [(ngModel)]="selectedBranches"
              #branchSelect="ngModel"
            >
              <mat-option
                (click)="selectAll(branchSelect, branchList)"
                [value]="0"
                >Select All</mat-option
              >
              <mat-option
                *ngFor="let branch of branchList"
                [value]="branch.id"
              >
                {{ branch.name }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Profile Status<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedProfile"
            >
              <option value="1">Active</option>
              <option value="0">Closed</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Closing Date<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedClosing"
            >
              <option value="">Select Date</option>
              <option
                *ngFor="let closing of closingDateList"
                [value]="closing.id"
              >
                {{ closing.closingDate }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Roles<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <mat-select
              multiple
              [(ngModel)]="selectedDesignation"
              #designateSelect="ngModel"
              name="designateSelect"
            >
              <mat-option
                (click)="selectAll(designateSelect, designationList)"
                [value]="0"
                >Select All</mat-option
              >
              <mat-option
                *ngFor="let designation of designationList"
                [value]="designation.id"
              >
                {{ designation.name }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </div>
      <!-- <div class="col-sm-3"></div> -->
      <div class="col-sm-2">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onViewReport()"
        >
          View Report
        </button>
      </div>
      <div class="col-sm-2" *ngIf="showExportToExcelButton">
        <button
          (click)="exportToExcelClick()"
          class="btn btn-sm btn-block btn-outline-theme"
        >
          <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
        </button>
      </div>
    </div>
  </div>
</div>
<div class="container" id="mainContent" *ngIf="showReportDetails || myReportIndicator">
  <div class="row pt-3 justify-content-center text-center">
    <span class="bg-theme-title"
      >P G BHAGWAT LLP, Chartered Accountants
    </span>
  </div>
  <div class="row justify-content-center text-center ">
    <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
  </div>

<div *ngFor="let partner of reportList">
  <div class="row pt-3">
    <label class="col-sm-4 col-form-label">{{ partner.designation }}</label>
  </div>

  <div class="table-responsive cnstr-record">
    <table class="table table-bordered heading-hvr">
      <tr>
        <th></th>
        <th>Partner Name</th>
        <th>Employee Name</th>
        <th>Branch</th>
        <th>Joining Date</th>
        <th>Exit Date</th>
        <th>Commitment Date</th>
        <th>UAN No.</th>
        <th>Total</th>
      </tr>
      <tbody *ngFor="let salary of partner.salaries">
        <tr>
          <td align="center">
            <a
              class="expand-row"
              *ngIf="!salary.hideMe"
              (click)="salary.hideMe = !salary.hideMe"
              >+</a
            >
            <a
              class="expand-row"
              *ngIf="salary.hideMe"
              (click)="salary.hideMe = !salary.hideMe"
              >-</a
            >
          </td>

          <td>{{ salary.partnerFName }} {{ salary.partnerLName }}</td>
          <td>{{ salary.firstName }} {{ salary.lastName }}</td>
          <td>{{ salary.branch }}</td>
          <td>{{ salary.joiningDate | date: "dd-MMM-yyyy" }}</td>
          <td>{{ salary.exitDate | date: "dd-MMM-yyyy" }}</td>
          <td>{{ salary.commitmentDate | date: "dd-MMM-yyyy" }}</td>
          <td>{{ salary.salaryDetails[0]?.uanNo }}</td>
          <td>{{ getTotalSalary(salary)}}</td>
        </tr>
        <tr class="sub-table" *ngIf="salary.hideMe">
          <td align="center"></td>
          <td colspan="10" class="p-0">
            <table class="table mb-0 table-striped">
              <thead style="background-color: lightskyblue">
                <tr>
                  <th colspan="4" style="border:1px solid black;"></th>
                  <th colspan="14" style="text-align:center; border:1px solid black;">Earnings</th>
                  <th colspan="13" style="text-align:center; border:1px solid black;">Deduction</th>
                </tr>
                <tr>
                  <th style="border-left:1px solid black;">Period</th>
                  <!-- Earnings -->
                  <th>Credit Hours</th>
                  <th>Debit Hours</th>
                  <th style="border-right:1px solid black;">Dr/Cr Hours</th>
                  <th>CTC</th>
                  <th>Basic</th>
                  <th>HRA</th>
                  <th>Conveyance Allowance</th>
                  <th>Other Allowance</th>
                  <th>OT</th>
                  <th>Reimbursement Conveyence</th>
                   <!-- <th>Total Travelling Amount</th> -->
                  <th>Expense Claims Amount</th>
                  <th>Advance</th>
                  <th>Loan</th>
                  <th>Exgratia</th>
                  <th>Leave Encashed Amount</th>
                  <th>EPF (ER)</th>
                  <th style="border-right:1px solid black;">ESIC (ER)</th>

                  <!-- Deductions -->
                   <!-- <th>Leave Days</th> -->
                   <th>LWP</th>
                  <th>Leave Amount</th>
                  <th>Security Deposit</th>
                  <th>Penalty</th>
                  <th>TDS</th>
                  <th>EPF (ER)</th>
                  <th>EPF (EE)</th>
                  <th>ESIC (ER)</th>
                  <th>ESIC (EE)</th>
                  <th>Professional Tax</th>
                  <!-- <th>Advance Travelling Allowance</th> -->
                   <th>Advance Travel Recovery</th>
                  <th>Recovery/Expenses</th>
                  <th style="border-right:1px solid black;">Loan EMI</th>                 
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let salaryDetail of salary.salaryDetails">
                  <Td style="border-left:1px solid black;"
                    >{{ getMonth(salaryDetail.month) }}-{{
                      salaryDetail.year
                    }}</Td
                  >
                  <td>
                    {{
                      getCreditHours(
                        salaryDetail.creditedTimeHours,
                        salaryDetail.creditedTimeMin
                      )
                    }}
                  </td>
                  <td>
                    {{
                      getCreditHours(
                        salaryDetail.debitedTimeHours,
                        salaryDetail.debitedTimeMin
                      )
                    }}
                  </td>
                  <td style="border-right:1px solid black;">
                    {{
                      getCreditDebitHours(
                        salaryDetail.creditedTimeHours,
                        salaryDetail.creditedTimeMin,
                        salaryDetail.debitedTimeHours,
                        salaryDetail.debitedTimeMin
                      )
                    }}
                  </td>
                  <td>{{ salaryDetail.ctc }}</td>
                  <td>{{ salaryDetail.basic }}</td>
                  <td>{{ salaryDetail.hra }}</td>
                  <td>{{ salaryDetail.conveyanceAllowance }}</td>
                  <td>{{ salaryDetail.otherAllowance }}</td>
                  <td>{{ salaryDetail.otAmount }}</td>
                  <td>{{ salaryDetail.conveyance }}</td>
                  <td>{{ salaryDetail.totalTravellingAmount }}</td>
                  <td>{{ salaryDetail.advance }}</td>
                  <td>{{ salaryDetail.loan }}</td>
                  <td>{{ salaryDetail.exgratia }}</td>
                  <td>{{ salaryDetail.leavesEncashedAmount }}</td>
                  <td>{{ salaryDetail.epfEmployerContribution }}</td>
                  <td style="border-right:1px solid black;">{{ salaryDetail.esicEmployerContribution }}</td>

                  <td>{{ getAbs(salaryDetail.leaveDays) }}</td>
                  <td>{{ getAbs(salaryDetail.leaveAmount) }}</td>
                  <td>{{ salaryDetail.securityDeposit }}</td>
                   <td>{{ salaryDetail.penaltyAmount }}</td>
                  <td>{{ salaryDetail.tds }}</td>
                  <td>{{ salaryDetail.epfEmployerContribution }}</td>
                  <td>{{ salaryDetail.epfEmployeeContribution }}</td>
                  <td>{{ salaryDetail.esicEmployerContribution }}</td>
                  <td>{{ salaryDetail.esicEmployeeContribution }}</td>
                  <td>{{ salaryDetail.professionalTax }}</td>
                  <!-- <td>{{ salaryDetail.providentFund }}</td> -->
                  <td>{{ salaryDetail.travellingAdvance }}</td>
                  <td>{{ salaryDetail.recoveryOrExpenses }}</td>
                  <td style="border-right:1px solid black;">{{ salaryDetail.emi }}</td>
                  <td>{{ getTotal(salaryDetail) }}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</div>
</div>
